import 'node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import 'node_modules/cssuseragent/cssua.js';
import 'node_modules/slick-carousel/slick/slick.js';
import '../node_modules/jquery-inview/jquery.inview.js';
import '../node_modules/jquery-parallax.js/parallax.min.js';
// import * as mapStyles from './mapstyle.json';
import 'pivot-base.js';

jQuery( document ).ready( function( $ ) {

  // Adds class when user starts scrolling
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    var objectSelect = $('body');
    var objectPosition = objectSelect.offset().top;
    if (scroll > objectPosition) {
        $('body').addClass('pd-scrolled');
    } else {
        $('body').removeClass('pd-scrolled');
    }
  });

// Makes dropdown links clickable
// $('li.dropdown').on('click', function() {
if (window.innerWidth > 991) {
  $('li.dropdown > a').on('click', function() {
    // var $el = $(this);
    // var $a = $el.children('a.dropdown-toggle');
    var $a = $(this);
    if ($a.length && $a.attr('href')) {
      location.href = $a.attr('href');
    }
  });
}

  let mapStyles2 = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#103339"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#28484a"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#0b272b"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#757575"
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#659585"
        },
        {
          "visibility": "on"
        },
        {
          "weight": 1.5
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#28484a"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#80c6af"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#659585"
        },
        {
          "visibility": "on"
        },
        {
          "weight": 2.5
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#53696b"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#181818"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#53696b"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1b1b1b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#0b272b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8a8a8a"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#28484a"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#28484a"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway.controlled_access",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#28484a"
        }
      ]
    },
    {
      "featureType": "road.local",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0a1c1f"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3d3d3d"
        }
      ]
    }
  ];

  // Change sort to fSelect FacetWP
  $(document).on('facetwp-loaded', function() {
    if ( $('.facetwp-sort-select').length ) {
      fSelect( '.facetwp-sort-select' );
    }
  });

  // FacetWP
  $( document ).off( 'change', '.facetwp-sort-select' ).on( 'change', '.facetwp-sort-select', function() {
    FWP.extras.sort = $( this ).val();
    FWP.soft_refresh = true;
  });

  // Needs to be in facetwp-loaded event or doesn't work on refresh
  $('.pd-map-slider-slick').slick({
    arrows: false,
    // prevArrow: '<a class="carousel-control-prev" role="button"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
    // nextArrow: '<a class="carousel-control-next" role="button"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
    dots: true,
    dotsClass: 'pd-slick-dots',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    fade: true,
    cssEase: 'linear',
    variableWidth: false,
    variableHeight: false,
    // appendDots: $('.pd-dots'),
    // prevArrow: $('.pd-slick-prev'),
    // nextArrow: $('.pd-slick-next')
  });

  /**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

  // Find marker elements within map.
  var $markers = $el.find('.marker');

  // Create gerenic map.
  var mapArgs = {
    backgroundColor: '#103339',
    zoom        : $el.data('zoom') || 16,
    disableDefaultUI: true, // a way to quickly hide all controls
    // mapTypeControl: true,
    // scaleControl: true,
    // zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.LARGE,
    },

    mapTypeId   : google.maps.MapTypeId.ROADMAP,
    styles      : mapStyles2
  };
  var map = new google.maps.Map( $el[0], mapArgs );

  // Add markers.
  map.markers = [];
  $markers.each(function(){
    initMarker( $(this), map );
  });

  // Center map based on markers.
  centerMapSingle( map );

  // Return map instance.
  return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
 function initMarker( $marker, map ) {

   // Get position from marker.
   var lat = $marker.data('lat');
   var lng = $marker.data('lng');
   var latLng = {
     lat: parseFloat( lat ),
     lng: parseFloat( lng )
   };

   // Create custom marker icon
   var defaultIcon = {
     url: '/wp-content/themes/brennan-investment-group/images/ico-marker.svg',
     scaledSize: new google.maps.Size(21, 34)
   };

   // Create marker instance.
   var marker = new google.maps.Marker({
     position : latLng,
     icon: defaultIcon,
     map: map
   });

   // Append to reference for later use.
   map.markers.push( marker );

   // If marker contains HTML, add it to an infoWindow.
   if( $marker.html() ){

     // Create info window.
     var infowindow = new google.maps.InfoWindow({
       content: $marker.html()
     });

     // Show info window when marker is clicked.
     google.maps.event.addListener(marker, 'click', function() {
       infowindow.open( map, marker );
     });
   }
 }

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
 function centerMap( map ) {

   // Create map boundaries from all map markers.
   var bounds = new google.maps.LatLngBounds();
   map.markers.forEach(function( marker ){
     bounds.extend({
       lat: marker.position.lat(),
       lng: marker.position.lng()
     });
   });

   // Case: Single marker.
   if( map.markers.length == 1 ){
     map.setCenter( bounds.getCenter() );

     // Case: Multiple markers.
   } else{
     map.fitBounds( bounds );
   }
 }

 function centerMapSingle( map ) {
   // console.log(map.markers);
   map.setZoom(15);
   var bounds = new google.maps.LatLngBounds();
   bounds.extend({
     lat: map.markers[0].position.lat() + .008,
     lng: map.markers[0].position.lng()
   });
   map.setCenter( bounds.getCenter() );
 }

// Render maps on page load.
// $('.acf-map').each(function(){
//   var map = initMap( $(this) );
// });

// On before slide change
if ($('.pd-map-slider .acf-map').length) {
  var sliderMap = initMap( $('.pd-map-slider .acf-map') );

  $('.pd-map-slider-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    let $nextSlide = $('.pd-map-slider-slick .slick-slide').eq(nextSlide);
    let nextLat = $nextSlide.find('.pd-map-slide-map').data('lat');
    let nextLng = $nextSlide.find('.pd-map-slide-map').data('lng');

    // sliderMap.setZoom(15);
    sliderMap.panTo({
      lat: nextLat + .008,
      lng: nextLng
    });
  });
}

// InView

$('.pd-fade').on('inview', function(event, isInView) {
  let _this = $(this);
  if (isInView) {
    setTimeout(function () {
      _this.addClass('pd-faded');
    }, 0);
  }
});

$('.pd-fade-2').on('inview', function(event, isInView) {
  let _this = $(this);
  if (isInView) {
    setTimeout(function () {
      _this.addClass('pd-faded');
    }, 800);
  }
});

$('.pd-fade-3').on('inview', function(event, isInView) {
  let _this = $(this);
  if (isInView) {
    setTimeout(function () {
      _this.addClass('pd-faded');
    }, 1600);
  }
});

$('.pd-fade-4').on('inview', function(event, isInView) {
  let _this = $(this);
  if (isInView) {
    setTimeout(function () {
      _this.addClass('pd-faded');
    }, 2400);
  }
});

// Removes text overlay on click
$('.pd-property-hero-wrapper').on('click', 'button', function() {
  $('.pd-property-text').addClass('d-none');
  $('.pd-property-text-lower').removeClass('d-none');
});

// Property Gallery

$( '.pd-gallery ul' ).slick({
      arrows:true,
      dots: true,
      dotsClass: 'pd-slick-dots',
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: false,
      touchMove: true,
      infinite: true,
      variableWidth: false,
      pauseOnHover:false
    });

    // News Post Gallery

$( '.pd-post-gallery ul' ).slick({
      arrows:true,
      dots: true,
      dotsClass: 'pd-slick-dots',
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: false,
      touchMove: true,
      infinite: true,
      variableWidth: false,
      pauseOnHover:false
    });


    // Hamburgers
    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Toggle Label
      $('.pd-toggle-label').html() == 'Close' ? $('.pd-toggle-label').html('Menu') : $('.pd-toggle-label').html('Close');
      // Toggle nav background
      $('body').toggleClass('pd-menu-open');
    });


    // Adds class to body when user scrolls reverse

    var lastScrollTop = 0;
    window.addEventListener("scroll", function(){
       var st = window.pageYOffset || document.documentElement.scrollTop;
       if (st > lastScrollTop){
          $('body').removeClass('pd-scroll-rev');
       } else {
          $('body').addClass('pd-scroll-rev');
       }
       lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


    // Move images on mobile
    function mobilePre() {
      if (window.innerWidth < 768) {
        $('.pd-image-pre').prependTo('.pd-mobile-col');
      } else {
        $('.pd-image-pre').prependTo('.pd-desktop-col');
      }
    }
    // Let's debounce our heavy lifts // https://css-tricks.com/snippets/jquery/done-resizing-event/
    var resizeTimer;
    mobilePre();
    $(window).on('resize', function(e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Run code here, resizing has "stopped"
        mobilePre();
      }, 250);
    });

});
